export default "__VITE_ASSET__CzJJbQZg__"